import type { Environment } from '..';

const cloudEnvironments = ['prod', 'stage', 'test', 'dev'] as const;
export const ENVIRONMENTS = [...cloudEnvironments, 'local'] as const;

interface BackendUriConfig {
    environment: Environment;
    urls: { [x in (typeof ENVIRONMENTS)[number]]: string };
    localEnvironmentOverride?: string;
}

export function backendUrl({
    environment,
    urls,
    localEnvironmentOverride,
}: BackendUriConfig) {
    if (!localEnvironmentOverride || environment === 'prod') {
        return urls[environment];
    }

    console.log(`Overriding backend url with: ${localEnvironmentOverride}`);
    return localEnvironmentOverride;
}
